import {AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, QueryList, ViewChildren} from '@angular/core';
import {ProtocolDto} from '../../../dtos/protocol.dto';
import {ProtocolAnalysisServiceResponseDto} from '../../../dtos/statistics/protocolAnalysisServiceResponseDto';
import {ResultsDirective} from '../resultsDirective';
import {ActivityDto} from '../../../dtos/activity.dto';
import {ActivityAnalysisResultDto} from '../../../dtos/statistics/activityAnalysisResultDto';
import {DynamicResultsLoaderService} from '../../../services/dynamic-results-loader.service';
import {ResultsViewType} from '../resultsViewType';
import {ActivityAnalysisServiceResponseDto} from "../../../dtos/statistics/activityAnalysisServiceResponseDto";
import {ViewMediumType} from "../viewMediumType";
import {BaseComponent} from "../../base/base.component";
import {KeyValue} from "common";

@Component({
    selector: 'app-protocol-summary-generic-results',
    templateUrl: './protocol-summary-generic-results.component.html',
    styleUrls: ['./protocol-summary-generic-results.component.scss']
})
export class ProtocolSummaryGenericResultsComponent extends BaseComponent implements OnInit, AfterViewInit {
    @Input()
    public protocol: ProtocolDto;

    @Input()
    public analysis: ProtocolAnalysisServiceResponseDto;

    @ViewChildren(ResultsDirective, {})
    public resultsHosts: QueryList<ResultsDirective>;

    public activityToAnalysisMap: KeyValue<ActivityDto, ActivityAnalysisServiceResponseDto>[];

    constructor(private resultsLoader: DynamicResultsLoaderService,
                private changeDetector: ChangeDetectorRef) {
        super();
    }

    ngOnInit(): void {
        if (!(this.analysis instanceof ProtocolAnalysisServiceResponseDto)) {
            return;
        }

        this.mapActivitiesToAnalysisResults(this.protocol.activities, this.analysis.protocolsResults[0].activitiesResults);
    }

    ngAfterViewInit(): void {
        // Load row results for each activity
        for (let i = 0; i < this.protocol.activities.length; i++) {
            const resultsHost = this.resultsHosts.get(i);
            const {key: activity, value: analysis} = this.activityToAnalysisMap[i];
            try {
                const resultsComponent = this.resultsLoader.forActivity(activity, resultsHost, analysis, ResultsViewType.ROW, ViewMediumType.SCREEN);
            } catch (e) {
                this.errorHandler.handle('Row results not supported.' + e.toString());
            }
        }

        // We are updating the view here while angular is validating changes.
        // Let it know we did changes. https://angular.io/errors/NG0100
        this.changeDetector.detectChanges();
    }

    private mapActivitiesToAnalysisResults(activities: ActivityDto[], activitiesResults: ActivityAnalysisResultDto[]) {
        this.activityToAnalysisMap = [];
        for (const activity of activities) {
            let result = activitiesResults.find(r => r.activityCode === activity.code);
            const mockServiceResponse = new ActivityAnalysisServiceResponseDto();
            mockServiceResponse.activitiesResults = [result];
            this.activityToAnalysisMap.push(KeyValue.of(activity, mockServiceResponse));
        }
    }
}
